'use client';

import { useCallback } from 'react';

import { useBrowsing } from 'hooks/use-browsing';

import { PUBLIC_LOGIN_URL_ENV } from 'tools/environments';

type UseRedirectProps = {
	path?: string;
	code?: number;
};

export const useRedirect = () => {
	const { asPath, basePath, push, isReady } = useBrowsing();

	const origin = typeof window !== 'undefined' ? window.location.origin : '';
	const url = `${origin}${basePath}${asPath}`;

	const redirect = useCallback(
		({ path, code }: UseRedirectProps) => {
			if (!isReady) return;

			if (!path && !code) return;

			if (path && !code) push(path);

			switch (code) {
				case 401:
					window.location.replace(
						`${PUBLIC_LOGIN_URL_ENV}?returnUrl=${url}`
					);
					break;
				case 404:
					push(path || '/404');
					break;
				case 400:
					push(path || '/404');
					break;
				case 500:
					push(path || '/500');
					break;
				default:
					break;
			}
		},
		[isReady, push]
	);

	return redirect;
};

export default useRedirect;
